/*
 * @Author: your name
 * @Date: 2021-01-20 11:06:35
 * @LastEditTime: 2021-05-12 15:09:20
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vue_admin\src\utils\get-page-title.js
 */
// import defaultSettings from '@/settings'

import store from '@/store'

export default function getPageTitle(pageTitle) {
  const title = store.state.settings.projectTitle

  if (pageTitle == '作战室') {
    return `${pageTitle} `
  }
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}
